import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';

class TimeTrackingDimensionValue extends DomainObject {
  name;
  dimensionId;
  archivedAt;
  employees;

  _relations = {
    _dates: ['archivedAt'],
    employees: [Employee]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      dimensionId: observable,
      archivedAt: observable,
      employees: observable,
      isArchived: computed
    });

    this.merge(other);
  }

  get isArchived() {
    return !!this.archivedAt;
  }
}

export default TimeTrackingDimensionValue;
